import classNames from "classnames"
import dayjs from "dayjs"
import { Button } from "react-bootstrap"

export default function ListGroupFilters({
    filters,
    setFilters,
    modalFiltersActions,
  }: {
    filters: any
    setFilters: any
    modalFiltersActions: any
  }) {
    return (
      <div
        className="list-group position-absolute bg-white rounded"
        style={{
          zIndex: 1000,
          width: 260,
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <button
          className={classNames('list-group-item list-group-item-action')}
          onClick={() => {
            setFilters({
              ...filters,
              verif_periodica: true,
              data_scadenza_periodica__gte: dayjs().format('YYYY-MM-DD'),
              data_scadenza_periodica__lte: dayjs()
                .add(1, 'month')
                .format('YYYY-MM-DD'),
              rapporto_taratura: '',
              data_scadenza_taratura__gte: '',
              data_scadenza_taratura__lte: '',
              data_intervento_periodica_aperto__isnull: '',
              data_intervento_periodica_aperto__gte: '',
              data_intervento_periodica_aperto__lte: '',
              data_intervento_taratura_aperto__isnull: '',
              data_intervento_taratura_aperto__gte: '',
              data_intervento_taratura_aperto__lte: '',
              con_richiesta_periodica: '',
              page: 1,
            })
          }}
        >
          V.P scadenze entro 30 giorni
        </button>
        <button
          className={classNames('list-group-item list-group-item-action')}
          onClick={() =>
            setFilters({
              ...filters,
              verif_periodica: true,
              data_scadenza_periodica__lte: dayjs().format('YYYY-MM-DD'),
              data_scadenza_periodica__gte: '',
              rapporto_taratura: '',
              data_scadenza_taratura__gte: '',
              data_scadenza_taratura__lte: '',
              data_intervento_periodica_aperto__isnull: '',
              data_intervento_periodica_aperto__gte: '',
              data_intervento_periodica_aperto__lte: '',
              data_intervento_taratura_aperto__isnull: '',
              data_intervento_taratura_aperto__gte: '',
              data_intervento_taratura_aperto__lte: '',
              con_richiesta_periodica: '',
              page: 1,
            })
          }
        >
          V.P scadute
        </button>
        <button
          className={classNames('list-group-item list-group-item-action')}
          onClick={() =>
            setFilters({
              ...filters,
              verif_periodica: 'true',
              con_richiesta_periodica: 'true',
              data_intervento_periodica_aperto__isnull: 'true',
              data_intervento_periodica_aperto__gte: '',
              data_intervento_periodica_aperto__lte: '',
              data_intervento_taratura_aperto__isnull: '',
              data_intervento_taratura_aperto__gte: '',
              data_intervento_taratura_aperto__lte: '',
              rapporto_taratura: '',
              data_scadenza_taratura__gte: '',
              data_scadenza_taratura__lte: '',
              data_scadenza_periodica__gte: '',
              data_scadenza_periodica__lte: '',
              page: 1,
            })
          }
        >
          V.P non programmate
        </button>
        <button
          className={classNames('list-group-item list-group-item-action')}
          onClick={() => {
            setFilters({
              ...filters,
              rapporto_taratura: 'true',
              data_scadenza_taratura__gte: dayjs().format('YYYY-MM-DD'),
              data_scadenza_taratura__lte: dayjs()
                .add(1, 'month')
                .format('YYYY-MM-DD'),
              verif_periodica: '',
              data_scadenza_periodica__gte: '',
              data_scadenza_periodica__lte: '',
              con_richiesta_periodica: '',
              data_richiesta_periodica__gte: '',
              data_richiesta_periodica__lte: '',
              data_intervento_periodica_aperto__isnull: '',
              data_intervento_periodica_aperto__gte: '',
              data_intervento_periodica_aperto__lte: '',
              data_intervento_taratura_aperto__isnull: '',
              data_intervento_taratura_aperto__gte: '',
              data_intervento_taratura_aperto__lte: '',
              page: 1,
            })
          }}
        >
          Tarature entro 30 giorni
        </button>
        <button
          className={classNames('list-group-item list-group-item-action')}
          onClick={() =>
            setFilters({
              ...filters,
              rapporto_taratura: true,
              data_scadenza_taratura__lte: dayjs().format('YYYY-MM-DD'),
              data_scadenza_taratura__gte: '',
              verif_periodica: '',
              data_scadenza_periodica__gte: '',
              data_scadenza_periodica__lte: '',
              con_richiesta_periodica: '',
              data_richiesta_periodica__gte: '',
              data_richiesta_periodica__lte: '',
              data_intervento_periodica_aperto__isnull: '',
              data_intervento_periodica_aperto__gte: '',
              data_intervento_periodica_aperto__lte: '',
              data_intervento_taratura_aperto__isnull: '',
              data_intervento_taratura_aperto__gte: '',
              data_intervento_taratura_aperto__lte: '',
              page: 1,
            })
          }
        >
          Tarature scadute
        </button>
        <div className="list-group-item list-group-item-action">
          <Button
            variant="outline-secondary"
            onClick={() => {
              modalFiltersActions.open()
            }}
            className="w-100 d-flex align-items-center justify-content-center"
          >
            <span className="material-icons me-2">edit</span>
            Personalizza
          </Button>
        </div>
      </div>
    )
  }